import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useBookingsSupabaseStore } from "@/store/api/bookingsSupabaseStore";
import { useEffect, useState } from "react";
import { ReservationsView } from "@/components/athlete/schedule/ReservationsView";
import { AthleteHistory } from "@/components/athlete/AthleteHistory";
import { AthleteBrandHeader } from "@/components/athlete/AthleteBrandHeader";
import { CalendarDays, ChartNoAxesColumnIncreasing, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface AthleteReservationsProps {
  initialTab?: "upcoming" | "history";
}

const AthleteReservations = ({ initialTab = "upcoming" }: AthleteReservationsProps) => {
  const { t } = useTranslation("athlete");
  const { fetchBookings } = useBookingsSupabaseStore();
  const [activeTab, setActiveTab] = useState<"upcoming" | "history">(initialTab);

  useEffect(() => {
    fetchBookings();
  }, [fetchBookings]);

  return (
    <div className="athlete-page-bg min-h-screen flex flex-col w-full">
      <main className="flex-1 px-4 py-5 md:p-6 max-w-7xl mx-auto w-full pb-24">
        <AthleteBrandHeader title={t('sessions.title')} backgroundKey="reservations" />
        <div className="athlete-segmented athlete-sessions-tabs mt-4" role="tablist" aria-label={t('sessions.title')}>
          <Button variant="ghost" role="tab" aria-selected={activeTab === "upcoming"} onClick={() => setActiveTab("upcoming")} className={cn(activeTab === "upcoming" && "is-active")}>
            <CalendarDays className="h-4 w-4" />{t('sessions.upcomingTab')}
          </Button>
          <Button variant="ghost" role="tab" aria-selected={activeTab === "history"} onClick={() => setActiveTab("history")} className={cn(activeTab === "history" && "is-active")}>
            <ChartNoAxesColumnIncreasing className="h-4 w-4" />{t('sessions.historyTab')}
          </Button>
        </div>
        {activeTab === "upcoming" && (
          <Button className="athlete-cta mt-5 h-14 w-full justify-center text-base font-bold" asChild>
            <Link to="/athlete/schedule">
              <CalendarDays className="h-5 w-5" />
              {t('reservations.bookClass')}
              <ChevronRight className="ml-auto h-5 w-5" />
            </Link>
          </Button>
        )}
        <div className="mt-5">
          {activeTab === "upcoming" ? <ReservationsView /> : <AthleteHistory compact />}
        </div>
      </main>
    </div>
  );
};

export default AthleteReservations;
